import { IOverdueInvoicePetInfo } from "./pendingInvoices.reducer";

export const actionTypes = {
  SET_CANCELLED_PET_LIST: "SET_CANCELLED_PET_LIST",
  SET_PAUSED_PET_LIST: "SET_PAUSED_PET_LIST",
  SET_OVERDUE_PET_LIST: "SET_OVERDUE_PET_LIST",
  SET_PENDING_PAYMENT_PET_LIST: "SET_PENDING_PAYMENT_PET_LIST",
  SET_SCRATCHPAY_OVERDUE_NOTICE_PET_IDS: "SET_SCRATCHPAY_OVERDUE_NOTICE_PET_IDS",
  SET_IS_OVERDUE_STORE_UPDATED: "SET_IS_OVERDUE_STORE_UPDATED",
  RESET_OVERDUE_INVOICE_STORE: "RESET_OVERDUE_INVOICE_STORE",
  SET_CANCELLED_PET_LIST_WITHOUT_OVERDUE: "SET_CANCELLED_PET_LIST_WITHOUT_OVERDUE",
};

const setCancelledPetList = (payload: IOverdueInvoicePetInfo[]) => ({
  type: actionTypes.SET_CANCELLED_PET_LIST,
  payload,
});

const setPausedPetList = (payload: IOverdueInvoicePetInfo[]) => ({
  type: actionTypes.SET_PAUSED_PET_LIST,
  payload,
});


const setOverduePetList = (payload: IOverdueInvoicePetInfo[]) => ({
  type: actionTypes.SET_OVERDUE_PET_LIST,
  payload,
});

const setPendingPaymentPetList = (payload: IOverdueInvoicePetInfo[]) => ({
  type: actionTypes.SET_PENDING_PAYMENT_PET_LIST,
  payload,
});

const setScratchpayOverdueNoticePetIds = (payload: string[]) => ({
  type: actionTypes.SET_SCRATCHPAY_OVERDUE_NOTICE_PET_IDS,
  payload,
});

const setIsOverdueStoreUpdated = (payload: boolean) => ({
  type: actionTypes.SET_IS_OVERDUE_STORE_UPDATED,
  payload,
});

const resetOverdueStore = () => ({
  type: actionTypes.RESET_OVERDUE_INVOICE_STORE,
});

const setCancelledPetListWithoutOverdue = (payload: IOverdueInvoicePetInfo[]) => ({
  type: actionTypes.SET_CANCELLED_PET_LIST_WITHOUT_OVERDUE,
  payload,
});


export default {
  setCancelledPetList,
  setPausedPetList,
  setOverduePetList,
  setPendingPaymentPetList,
  setScratchpayOverdueNoticePetIds,
  setIsOverdueStoreUpdated,
  resetOverdueStore,
  setCancelledPetListWithoutOverdue,
};
